// extracted by mini-css-extract-plugin
module.exports = {"moderation-paginator":"moderationPaginator_moderation-paginator__1oNiO"};